<template>
  <div>
    <form-table-page
      class="index-all-box"
      :data="formData"
      :label="formLabel"
      @Query="Query"
      @Reset="Reset"
    >
      <template slot="OrderCode">
        <el-input v-model="formData.OrderCode" />
      </template>

      <template slot="OrderCodes">
        <el-input v-model="formData.OrderCodes" />
      </template>

      <template slot="OrderCodess">
        <el-input v-model="formData.OrderCodess" />
      </template>

      <template slot="OrderCodessx">
        <el-input v-model="formData.OrderCodessx" />
      </template>

      <template slot="OrderCodessxx">
        <el-input v-model="formData.OrderCodessxx" />
      </template>
    </form-table-page>

    <div class="table-content-box">
      <div class="btn-list-box">
        <el-button type="primary" round>Add</el-button>
        <el-button type="primary" round>Import</el-button>
        <el-button type="danger" round>Delete</el-button>
      </div>

      <table-page :table-data="tableData">
        <template slot="tableItem">
          <el-table-column prop="date" label="日期" />
          <el-table-column prop="name" label="姓名" />
          <el-table-column
            prop="address"
            label="地址"
            show-overflow-tooltip
          />
        </template>
      </table-page>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data() {
    return {
      formData: {
        OrderCode: '1111',
        OrderCodes: '2122',
        OrderCodess: '2122',
        OrderCodessx: '2122',
        OrderCodessxx: '2122'
      },
      formLabel: {
        OrderCode: '订单号',
        OrderCodes: '订单号2',
        OrderCodess: '订单号3',
        OrderCodessxx: '订单号3',
        OrderCodessx: '订单号3'
      },
      tableData: [
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        },
        {
          date: '2016-05-07',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }
      ]
    }
  },
  mounted() {
    const self = this
    window.index = self
  },
  methods: {
    /**
     * 查询方法
     * @constructor
     */
    Query(type) {
      console.log('查询', type)
    },

    /**
     * 重置
     * @constructor
     */
    Reset() {
      console.log('重置')
    }
  }
}
</script>

<style scoped lang="scss">

</style>
